export default "__VITE_ASSET__ea814555__"